import { React, useEffect, useState, useRef } from "react";
import { TextField } from "@mui/material";
import { istInteger } from "../../lib";

export default function MonthTextField(props) {
  const { value, onChange } = props;
  const [selectionChange, setSelectionChange] = useState(false);
  const selection = useRef(0);

  useEffect(() => {
    document
      .getElementById("field")
      .setSelectionRange(selection.current, selection.current);
    // eslint-disable-next-line
  }, [selectionChange]);

  function CheckKey(event) {
    if (event.keyCode === 8) {
      //BACKSPACE
      event.preventDefault();
      var tmpvalue = document.getElementById("field").value;
      var newcursorpos = event.target.selectionStart - 1;
      if (newcursorpos === 2) {
        selection.current = newcursorpos;
        setSelectionChange(!selectionChange);
        return;
      }
      if (newcursorpos >= 0) {
        tmpvalue =
          tmpvalue.substr(0, newcursorpos) +
          "0" +
          tmpvalue.substr(newcursorpos + 1);
        tmpvalue = tmpvalue.replace(/[^0-9 ]/g, "");
        onChange(tmpvalue.substr(2, 4) + "-" + tmpvalue.substr(0, 2));
        selection.current = newcursorpos;
        setSelectionChange(!selectionChange);
      }
    }
    if (event.keyCode === 46) {
      //DELETE
      event.preventDefault();
      var tmpvalue = document.getElementById("field").value;
      var cursorpos = event.target.selectionStart;
      console.log(cursorpos);
      if (cursorpos === 2 || cursorpos > 6) return;
      if (cursorpos === 0) {
        tmpvalue = "0" + tmpvalue.substr(1);
      } else {
        tmpvalue =
          tmpvalue.substr(0, cursorpos) + "0" + tmpvalue.substr(cursorpos + 1);
      }

      tmpvalue = tmpvalue = tmpvalue.replace(/[^0-9 ]/g, "");
      onChange(tmpvalue.substr(2, 4) + "-" + tmpvalue.substr(0, 2));
      selection.current = cursorpos;
      setSelectionChange(!selectionChange);
    }
  }

  function Format(newValue) {
    var tmpvalue = newValue.target.value;
    var cursorpos = newValue.target.selectionStart;
    if (cursorpos > 3) cursorpos--;

    tmpvalue = tmpvalue.replace(/[^0-9 ]/g, "");

    if (tmpvalue.length < 6) {
      tmpvalue = tmpvalue.padStart(6, "0");
      cursorpos = 7;
    }

    if (istInteger(tmpvalue) === false) {
      return;
    }

    if (tmpvalue.length > 6) {
      if (cursorpos > 6) {
        tmpvalue = tmpvalue.slice(-6);
      } else {
        tmpvalue =
          tmpvalue.substr(0, cursorpos) + tmpvalue.substr(cursorpos + 1);
      }
    }

    onChange(tmpvalue.substr(2, 4) + "-" + tmpvalue.substr(0, 2));

    selection.current = cursorpos === 1 ? cursorpos : cursorpos + 1;
    setSelectionChange(!selectionChange);
  }

  function checkRange(newValue) {
    var tmpvalue = newValue.replace(/[^0-9 ]/g, "");
    var monat = tmpvalue.substr(0, 2);
    var jahr = tmpvalue.substr(2, 4);
    if (Number(monat) > 12) {
      monat = "12";
      Format({ target: { value: monat + "/" + jahr } });
    }
  }

  function getValue() {
    var tmpvalue = value;

    tmpvalue = tmpvalue.replace(/[^0-9 ]/g, "");
    if (Number(tmpvalue) === 0) return "00/0000";
    if (tmpvalue.length > 6) tmpvalue = tmpvalue.slice(-6);
    if (tmpvalue.length < 6) tmpvalue = tmpvalue.padStart(6, "0");
    return tmpvalue.substr(4, 2) + "/" + tmpvalue.substr(0, 4);
  }

  return (
    <>
      {/* {window.cordova && (
        <TextField
          {...props}
          type="month"
          id="field"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          InputProps={{
            ...props.inputProps,
          }}
        />
      )}
      {!window.cordova && ( */}
      <TextField
        {...props}
        id="field"
        value={getValue()}
        onKeyDown={(e) => CheckKey(e)}
        onChange={(e) => Format(e)}
        onBlur={(e) => checkRange(e.target.value)}
        InputProps={{
          ...props.inputProps,
        }}
      />
      {/* )} */}
    </>
  );
}
